export default __webpack_public_path__ + "static/Placeholder2-2bd57ad3a08e6f5ac159b9851e020fb3.svg";